module.exports = __webpack_public_path__ + "img/slide-15_small.31360305.png";